module.exports = __webpack_public_path__ + "static/media/maira.041af083.jfif";